/**
 * KAN-776: общие поля партии архивов: префикс метки на всю партию (пусто:
 * сервер подбирает по стране номера) и флаги "включить" и "писать первым".
 * Прокси здесь нет: его назначает сервер по стране (см. план партии).
 */
import { Label } from '@/components/ui/label';
import { NativeSelect } from '@/components/ui/native-select';
import { Switch } from '@/components/ui/switch';
import { FLAGS_HINT } from '@/components/telegram/ConnectCommonFields';
import { useTelegramLabelPrefixes } from '@/hooks/useTelegramLabelPrefixes';
import type { BatchCommonValues } from '@/lib/telegramImportBatch';

export const AUTO_PREFIX_OPTION = 'Автоматически (по стране номера)';
export const PROXY_BY_SERVER_HINT = 'Прокси назначает сервер по стране номера.';

interface Props {
  values: BatchCommonValues;
  onChange: (patch: Partial<BatchCommonValues>) => void;
  disabled?: boolean;
}

export function BatchCommonFields({ values, onChange, disabled }: Props): JSX.Element {
  const { data } = useTelegramLabelPrefixes();
  const options = [
    { value: '', label: AUTO_PREFIX_OPTION },
    ...(data ?? []).map((p) => ({ value: p.code, label: p.code })),
  ];
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <Label htmlFor="batch-label-prefix">Метка</Label>
        <NativeSelect
          id="batch-label-prefix"
          data-testid="batch-label-prefix-select"
          aria-label="Префикс метки"
          options={options}
          value={values.labelPrefix}
          disabled={disabled}
          onChange={(e) => onChange({ labelPrefix: e.target.value })}
        />
        <p className="text-xs text-gray-500" data-testid="batch-proxy-hint">
          {PROXY_BY_SERVER_HINT}
        </p>
      </div>
      <div className="flex items-center justify-between gap-3">
        <Label htmlFor="batch-enabled">Включить после подключения</Label>
        <Switch
          id="batch-enabled"
          data-testid="batch-enabled-switch"
          checked={values.enabled}
          disabled={disabled}
          onCheckedChange={(enabled) => onChange({ enabled })}
        />
      </div>
      <div className="flex items-center justify-between gap-3">
        <Label htmlFor="batch-outreach">Писать первым</Label>
        <Switch
          id="batch-outreach"
          data-testid="batch-outreach-switch"
          checked={values.outreach}
          disabled={disabled}
          onCheckedChange={(outreach) => onChange({ outreach })}
        />
      </div>
      <p className="text-xs text-gray-500">{FLAGS_HINT}</p>
    </div>
  );
}
